import React, { useState } from 'react';
import { Box, Button, CircularProgress, DialogTitle, makeStyles, TextField, Typography, useMediaQuery } from '@material-ui/core'
import AppDialog from '../../components/AppDialog';
import api  from '../../services/api'
import { useSelector, useDispatch} from 'react-redux';
import { SELECTOR_SHOPPING_CART_ID } from '../../redux/selectors/shoppingCart';
import { SELECTOR_DISCOUNT } from '../../redux/selectors/discounts'
import { setDiscount, setDiscountId } from '../../redux/actions/discounts'
import { SELECTOR_FULFILLMENT_CURRENT } from '../../redux/selectors/fulfillments';

const useStyles = makeStyles(theme => ({
	card: {
		border: '1px solid rgba(122,122,122,0.6)',
    borderRadius: 5,
	},
	dialogTitle: {
		textAlign: 'center',
		padding: 0
	},
	code: {
		fontSize: 18,
		fontWeight: 200
	}
}))

export function ApplyDiscount() {
	const shoppingCartId = useSelector(SELECTOR_SHOPPING_CART_ID);
	const fulfillment = useSelector(SELECTOR_FULFILLMENT_CURRENT)
	const discount = useSelector(SELECTOR_DISCOUNT)

	const [open, setOpen] = useState(false)
	const [code, setCode] = useState('')
	const [error, setError] = useState('')
	const [loading, setLoading] = useState(false)

	const classes = useStyles()
	const smScreen = useMediaQuery('(max-width: 768px)');

	const dispatch = useDispatch()

	const handleChange = e => {
		const { value } = e.target
		setCode(value)
		setError('')
	}

	const handleClose = () => {
		setError('')
		setCode('')
		setLoading(false)
		setOpen(false)
	}

	const handleChangeCode = () => {
		dispatch(setDiscountId(0))
		dispatch(setDiscount(null))
		setOpen(true)
	}

	const handleConfirm = async () => {
		if (!code) {
			 setError('Por favor ingrese el código')
			 return
		}
		setLoading(true)
		setError('')
		const discount = await api.discounts.find({ query: {
			code,
			$client: {
				checkIfApplicable: 'true',
				shopping_cart_id: shoppingCartId,
				shippingCost: fulfillment?.price || 0
			}
		} })
		.then(it => ({
			extra: it.extra,
			...(it.data[0])
		}))
		.catch(err => {
			if ([400, 401, 404, 406].includes(err.code)) setError(err.message)
			else setError('Algo salió mal, intenta nuevamente')
		})
		.finally(() => {
			setLoading(false)
		})

		if (discount) {
			dispatch(setDiscountId(discount.id))
			dispatch(setDiscount(discount))
			handleClose()
		}
	}

	return (
		<Box
			className={classes.card}
			mb={2}
			p={2}
			display={smScreen ? 'block' : 'flex'}
			{...(smScreen ? { textAlign: 'center' } : { justifyContent: 'space-between', alignItems: "center" })}

		>
			<Typography component="h4" color="textSecondary">
				{discount ? 'Código de descuento:' : '¿Tienes un código de descuento?'}
			</Typography>
			{!discount && <Button onClick={() => setOpen(true)}>Ingresar código</Button>}
			{!!discount && <Typography variant="caption" className={classes.code}>{discount.code}</Typography>}
			{!!discount && <Box><Button variant="text" color="primary" onClick={handleChangeCode}>Cambiar</Button></Box>}

			<AppDialog
				open={open}
				maxWidth={400}
				handleClose={handleClose}
			>
			<Box p={2}>
					<DialogTitle className={classes.dialogTitle}>
						Ingresar código
					</DialogTitle>
					<Box mt={3} mb={3} display="flex" justify="center">
						<TextField autoComplete="off" fullWidth name='code' value={code} onChange={handleChange} error={error} helperText={error} />
					</Box>
					<Box mb={1}>
						<Button fullWidth variant="contained" color="primary" onClick={handleConfirm}>
							{
							loading
								? <CircularProgress color="inherit" size="25px" />
								: 'Confirmar'
							}
						</Button>
					</Box>
					<Box>
						<Button fullWidth variant="outlined" color="secondary" onClick={handleClose} disabled={loading}>Cancelar</Button>
					</Box>
			</Box>
			</AppDialog>
		</Box>
	)
}